import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "news" }
const _hoisted_2 = { class: "news-content" }
const _hoisted_3 = { class: "yyal-content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "detail" }

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import BannerC from '@/components/BannerC.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUs',
  setup(__props) {

const store = useStore()
const newsList: any = ref([])
const router = useRouter()
const oldNewsList: any = ref([])
const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}

onMounted(() => {
  selectCommonElement({ columnId: 5 }).then((res: any) => {
    oldNewsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).map((e: any) => {
      const date = new Date(e.newsTimestamp || e.createTime)
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      e.createTime = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
      return e;
    })
    newsList.value =  oldNewsList.value.slice(0, 6)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-font-style-m" }, "新闻动态", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (toOtherPath(`/news_detail?id=${item.id}&pathName=关于我们,新闻动态,新闻详情`, ['关于我们', '新闻动态', '新闻详情']))
            }, [
              _createElementVNode("img", {
                src: item.ossPath
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.introduction), 1),
                _createElementVNode("div", null, _toDisplayString(item.createTime), 1)
              ])
            ], 8, _hoisted_4))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})